import { INote } from './NotesClient';
import { FileUploader } from './FileUploader';

export class NoteValidator {
    static inject = () => [FileUploader];
    constructor(private fileUploader: FileUploader){

    }
    isValid = (note: INote): boolean => {
        const hasOneOfRequiredFields = Boolean(note.html) || Boolean(note.title) || note.attachments?.length > 0;
        return this.fileUploader.getUploadingCount() === 0 && hasOneOfRequiredFields;
    };
}
